/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-07-05 14:35:54
 * @LastEditTime: 2020-05-09 18:47:06
 * @LastEditors: 山淑兰
 */
/**
 * Created by Cray on 2017/1/5.
 */

import Rating from "./modules/ratings"; // 内容管理
import Meeting from "./modules/meeting"; // 会议基本信息
import SignUp from "./modules/signUp"; // 报名
import Pay from "./modules/pay/index"; // 支付
import personalCenter from "./modules/personalCenter"; // 支付
import Token from "./modules/token/index"; //获取token
import schedule from "./modules/schedule"; // 日程
import live from "./modules/live"; // 直播
import expert from "./modules/expert"; // 嘉宾

export default Object.assign(
  {},
  // Host,
  {
    Rating,
    Meeting,
    SignUp,
    Pay,
    Token,
    personalCenter,
    schedule,
    live,
	expert
  },
);
